import React from 'react';
import Input from '@zg-rentals/multibrand-ui/lib/Input';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import SpacerRow from '@zg-rentals/multibrand-ui/lib/SpacerRow';
import SpinnerContainer from '@common/components/SpinnerContainer';
import Modal from '@common/components/Modal';
import userPersonas from '@common/constants/userPersonas';
import FaqComponent from '@common/components/FaqComponent';
import FaqConstants from '@rental-manager/constants/FaqConstants';
import { validateAllInputs } from './validation';

interface Props {
  onSubmit: ({ emailAddress, phoneNumber }) => any;
}

const EditStripeContactInfoModal: React.FC<React.PropsWithChildren<Props>> = (props: Props): JSX.Element => {
  const initialEmailAddress = {
    value: '',
    error: '',
  };

  const initialPhoneNumber = {
    value: '',
    error: '',
  };

  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [emailAddress, setEmailAddress] = React.useState<Record<string, any>>(initialEmailAddress);
  const [phoneNumber, setPhoneNumber] = React.useState<Record<string, any>>(initialPhoneNumber);

  const onInputChange = (e): void => {
    const updateObject = { value: e.currentTarget.value, error: '' };
    switch (e.currentTarget.dataset.statekey) {
      case 'emailAddress':
        setEmailAddress(updateObject);
        break;
      case 'phoneNumber':
        setPhoneNumber(updateObject);
        break;
      default:
        break;
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();

    const errors = validateAllInputs(emailAddress.value, phoneNumber.value);
    if (!errors.hasErrors) {
      return Promise.resolve()
        .then(() => setIsLoading(true))
        .then(() => {
          return props.onSubmit({
            emailAddress: emailAddress.value.trim(),
            phoneNumber: phoneNumber.value.trim(),
          });
        })
        .then((response = {}) => {
          if (response.error) {
            setIsLoading(false);
          }
        });
    } else {
      setEmailAddress({ value: emailAddress.value, error: errors.emailAddressError });
      setPhoneNumber({ value: phoneNumber.value, error: errors.phoneNumberError });
      return false;
    }
  };

  return (
    <Modal persona={userPersonas.LANDLORD} header="Payment setup" dataAutoTestId="update-stripe-contact-information">
      {isLoading && <SpinnerContainer />}
      <Row>
        <Col>
          <Text type="h3">Update my contact information with Stripe</Text>
        </Col>
      </Row>
      <Row>
        <Col>
          <Input
            data-statekey="emailAddress"
            className="fs-exclude"
            label="Email address"
            value={emailAddress.value}
            error={emailAddress.error}
            onChange={onInputChange}
          />
        </Col>
        <SpacerRow size="sm" />
        <Col>
          <Input
            className="fs-exclude"
            data-statekey="phoneNumber"
            label="Phone Number"
            value={phoneNumber.value}
            error={phoneNumber.error}
            onChange={onInputChange}
          />
        </Col>
      </Row>
      <SpacerRow size="sm" />
      <Row>
        <Col>
          <FaqComponent.Landlord faqs={FaqConstants.DASHBOARD_V2.EDIT_STRIPE_CONTACT_INFO_MODAL} />
        </Col>
      </Row>
      <Row>
        <Col>
          <Button type="primary" full onClick={onSubmit}>
            Update
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default EditStripeContactInfoModal;
